const baseUrl = 'https://sorelogic.amatis.dev';

export const environment = {
  production: false,
  env: 'dev',
  basePath: baseUrl,
  apiLocations: {
    cookieDomain: '.amatis.dev',
    cookieName: 'Amatis-Sore-dev',
    identity: `${baseUrl}/api/identity/v1`,
    patient: `${baseUrl}/api/patient/v1`,
    appointment: `${baseUrl}/api/appointment/v1`,
    organization: `${baseUrl}/api/organization/v1`,
    patientHub: `${baseUrl}/api/patient-hub/v1`,
    customer: `${baseUrl}/api/customer/v1`,
    chat: `${baseUrl}/api/communication/v1`,
    notification: `${baseUrl}/api/notification/v1`,
    communication: `${baseUrl}/api/communication/v1`,
  },
  hubs: {
    chatHub: {
      name: 'chat-hub',
      url: `${baseUrl}/communication`,
      queryParams: {
        groupId: 'groupId',
        groupType: 'groupType',
      },
    },
    callHub: {
      name: 'call-hub',
      url: `${baseUrl}/communication`,
      queryParams: {
        userId: 'userId',
      },
    },
    woundHub: {
      name: 'wound-hub',
      url: `${baseUrl}/patient`,
      queryParams: {
        facilityId: 'groupId',
      },
    },
    notificationHub: {
      name: 'notification-hub',
      url: `${baseUrl}/identity`,
      queryParams: {
        userId: 'userId',
      },
    },
    communicationHub: {
      name: 'communication-hub',
      url: `${baseUrl}/communication`,
      queryParams: {
        userId: 'userId',
      },
    },
  },
  webrtc: {
    iceServers: [
      { urls: 'stun:stun.l.google.com:19302' },
      { urls: 'stun:stun.services.mozilla.com' },
    ],
    iceTransportPolicy: 'all' as RTCIceTransportPolicy,
    iceConfigPath: '/turn-configs/ice',
    disconnectedGraceMs: 4000,
  },
  theme: {
    colors: {
      'brand-primary': '#FF7900',
      'brand-primary-rgb': '255, 121, 0',
      'brand-primary-active': '#cc6100',
      'brand-primary-light': 'rgba(255, 121, 0, 0.12)',
      'surface-dark': '#232323',
      'surface-darker': '#1e1e1e',
      'surface-mid': '#2a2a2a',
      'border-default': '#444444',
      'border-strong': '#333333',
      'text-primary': '#ffffff',
      'text-dark': '#000000',
      'text-secondary': '#b3b3b3',
      'text-muted': '#666666',
      'tooltip-bg': '#111111',
      'overlay-bg': 'rgba(0, 0, 0, 0.88)',
      'gray-font': 'rgb(141, 147, 160)',
      'pivot-bg': '#FF7900',
      'pivot-border': '#cc6100',
      'btn-secondary-bg': '#232323',
      'btn-secondary-border': '#232323',
    },
  },
};
